import React, { FC, ReactNode } from "react";
import { Provider } from "react-redux";
import { ChakraProvider, CSSReset } from "@chakra-ui/react";
import { ErrorBoundary } from "@sentry/react";
import { store } from "~/store/store";
import { customTheme } from "./theme";

interface Props {
  children: ReactNode;
}

const { VITE_ENVIRONMENT } = import.meta.env;

export const AppProvider: FC<Props> = ({ children }) => (
  <ErrorBoundary showDialog={VITE_ENVIRONMENT !== "development"}>
    <Provider store={store}>
      <React.StrictMode>
        <ChakraProvider theme={customTheme}>
          <CSSReset />
          {children}
        </ChakraProvider>
      </React.StrictMode>
    </Provider>
  </ErrorBoundary>
);
